import { ofType } from 'redux-observable';
import { mergeMap, map, takeUntil } from 'rxjs/operators';
import { actions } from './actions';
import { api, rx, cx } from '../../../api';
import { errorMap } from '../../actions';

const defaultState = {
	list: null,
	map: null,
	pending: false,
	error: null
};

// -----------------------------------------------------

function reducer(state, action) {
	switch (action.type) {
		case actions.countries.request.type:
			return state = {
				...state,
				pending: true,
				error: null
			};
		case actions.countries.success.type:
			return state = {
				...state,
				list: action.list,
				map: cx.i.hash(action.list, country => country.code),
				pending: false,
				error: null
			};
		case actions.countries.fail.type:
			return state = {
				...state,
				pending: false,
				error: action.errorMessage
			};
		default:
			return state || defaultState;
	}
}

// --------------------------------------------------------

const epic = (action$) => {
	return action$.pipe(
		ofType(actions.countries.request.type),
		mergeMap(action =>
			rx(api.registry.countries).pipe(
				map(operation => actions.countries.success({ list: operation.response() })),
				errorMap(actions.countries.fail),
				takeUntil(action$.pipe(ofType(actions.countries.cancel.type)))
			)
		)
	)
}

export { reducer, epic };
